import { SearchHandlerInfo } from '~/api/repository'
import { searchFilterType } from '~/types/search-filter.type'

export class TransactionResultModel {
  private readonly _hash: string
  private readonly _version: string

  constructor (hash: string, version: string) {
    this._hash = hash
    this._version = version
  }

  get hash () {
    return this._hash
  }

  get version () {
    return this._version
  }
}

export class ModuleResultModel {
  private readonly _address: string
  private readonly _moduleName: string

  constructor (address: string, moduleName: string) {
    this._address = address
    this._moduleName = moduleName
  }

  get address () {
    return this._address
  }

  get moduleName () {
    return this._moduleName
  }
}

// TODO: any 수정
export class SearchModel {
  private _resultMap: Map<string, Record<string, any>> = new Map<string, Record<string, any>>()
  private _maxResultCount = 10
  private _maxResultCountPerFilter = 5

  constructor (res: Array<SearchHandlerInfo>) {
    res.forEach((result) => {
      if (result.IDX) {
        const resultList = result.SRLIST || []
        if (result.IDX === searchFilterType.TRANSACTION) {
          this._resultMap.set(result.IDX, resultList.map((transaction: {
            TRXHA: string,
            VER: string
          }) => new TransactionResultModel(transaction.TRXHA, transaction.VER)))
          return
        }
        if (result.IDX === searchFilterType.MODULE) {
          this._resultMap.set(result.IDX, resultList.map((module: {
            ADDR: string,
            MDNM: string
          }) => new ModuleResultModel(module.ADDR, module.MDNM)))
          return
        }
        this._resultMap.set(result.IDX, resultList)
      }
    })

    this.sliceResult(searchFilterType.BLOCK, searchFilterType.TRANSACTION)
    this.sliceResult(searchFilterType.TRANSACTION, searchFilterType.BLOCK)
    this.sliceResult(searchFilterType.TRANSACTION, searchFilterType.ADDRESS)
    this.sliceResult(searchFilterType.ADDRESS, searchFilterType.TRANSACTION)
    this.sliceResult(searchFilterType.MODULE)
  }

  private sliceResult (key: searchFilterType, relatedKey?: searchFilterType) {
    if (!relatedKey) {
      this._resultMap.set(key, this._resultMap.get(key)!.slice(0, this._maxResultCount))
      return
    }
    const sliceCount = this._maxResultCount - Math.min(this._resultMap.get(relatedKey)!.length, this._maxResultCountPerFilter)
    this._resultMap.set(key, this._resultMap.get(key)!.slice(0, sliceCount))
  }

  get resultMap () {
    return this._resultMap
  }
}